import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { OpenDeliveryIntegradoresForm } from "./components/OpenDeliveryIntegradoresForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integradores Open Delivery" />
            <Loading />
            <OpenDeliveryIntegradoresForm />
        </>
    )
}
